import React, { useEffect } from 'react';
import { ViewPort } from 'react-spaces';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import { Sidebar } from 'semantic-ui-react';
import io from 'socket.io-client';

import LocalStorage from 'src/utils/LocalStorage';
import { PATH } from 'src/constants/app';
import { useAppDispatch, useAppSelector } from 'src/store';
import { fetchMe } from 'src/thunks/auth';
import {
  ClassTopicContentDrawer,
  Header,
  NotificationHistoryDrawer,
} from 'src/components/coreUI';
import { ClassSiderDrawer, SiderDrawer } from 'src/components/coreUI';
import { useHistoryListener } from 'src/hooks';
import drawer from 'src/store/ui/drawer';
import SocketProvider from 'src/components/applications/SocketProvider';
import { ENV } from 'src/env';

const socket = io(ENV.API.SOCKET, { autoConnect: false });

const Authenticated: React.FC = () => {
  const authInfo = LocalStorage.authInfo;
  const accessToken = LocalStorage.accessToken;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const visible = useAppSelector((state) => state.ui.drawer.visible);

  useEffect(() => {
    if (!accessToken) return navigate(PATH.LOGIN);

    dispatch(
      fetchMe({
        access_token: accessToken!,
        refresh_token: LocalStorage.refreshToken!,
      }),
    );
  }, []);

  useHistoryListener(() => dispatch(drawer.close({ name: '' })));

  return authInfo ? (
    <ViewPort>
      <SocketProvider socket={socket}>
        <Sidebar.Pushable>
          <ClassTopicContentDrawer />
          <NotificationHistoryDrawer />
          <ClassSiderDrawer />
          <SiderDrawer />

          <Sidebar.Pusher dimmed={visible}>
            <Header />
            <Outlet />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </SocketProvider>
    </ViewPort>
  ) : (
    <Navigate to={PATH.LOGIN} />
  );
};

export default Authenticated;
